import React, { Component } from 'react';
import M from 'materialize-css/dist/js/materialize';
import { Button } from './ComponentsUI';
import { translate } from '../../utils/util';

class ConfirmModal extends Component {
    componentDidMount() {
        this.instance = M.Modal.init(this.modal);
    }

    onConfirm = () => {
        if (this.props.onConfirm) {
            this.props.onConfirm();
        }
        this.close();
    }

    onCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
        this.close();
    };

    close() {
        if (this.props.onClose) {
            this.props.onClose();
        }
        M.Modal.getInstance(this.modal).close();
    }

    show() {
        this.instance.open();
    }

    render() {
        return (
            <div>
                <div id={this.props.id ? this.props.id : 'confirm-modal'} ref={(modalEl) => this.modal = modalEl} className="modal" style={{ backgroundColor: '#ffffff' }}>
                    <div className="modal-content black-text">
                        <h4>{this.props.data.title}</h4>
                        {this.props.data.message}
                    </div>
                    <div className="modal-footer" style={{ backgroundColor: '#ffffff' }}>
                        <div className="row" >
                            <div className="col s6">
                                <Button
                                    full="true"
                                    onClick={this.onCancel}
                                    secundary="true"
                                    text={this.props.btnCancel ? this.props.btnCancel : translate('cancel', 'general')}
                                />
                            </div>
                            <div className="col s6">
                                <Button
                                    full="true"
                                    onClick={this.onConfirm}
                                    text={this.props.btnConfirm ? this.props.btnConfirm : translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfirmModal;
